export default __webpack_public_path__ + "static/media/next-arrow.de604c82.svg";